import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { shareReplay, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../core/services/authentication.service';
import { LogCategory, LoggerService, LogService, LogType } from '../core/services/logger.service';


@Injectable()
export class PointsTrackingService {

    private _trackingGroups$: Observable<any> = null;
    private _reload$ = new Subject<void>();             // used to trigger resubscribe/reload
    private _subNewUser: Subscription = null;           // new user subscription for spoof/unspoof events


    constructor(
        private http: HttpClient,
        private logger: LoggerService,
        private auth: AuthenticationService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
        this._subNewUser = auth.loggedInUser$.subscribe(() => {
            this.update();
        })
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Service, LogService.PointsTracking, category);
    }

    public update() {
        // Update the profile by calling the API again
        this.log("update");
        this._reload$.next();
        this._trackingGroups$ = null;

        // Use the property to cause it to try to fetch 
        var v = this._trackingGroups$;
    }
    
    public get trackingGroups$() {

        if (!this._trackingGroups$) {
            this._trackingGroups$ = this.http.get<any>(environment.apiUrl + '/pointstracking')
                .pipe(
                    tap((data) => this.processApiResult(data)),
                    takeUntil(this._reload$),
                    shareReplay(1)
            );
        }
        return this._trackingGroups$;
    }

    private processApiResult(apiResult : object[]) {
        this.log('trackingGroups$', 'Fetched points tracking groups', LogCategory.SubscriptionData)
        for (var i = 0; i < apiResult.length; i++) {
            this.updateCompletionMessage(apiResult[i]);
        }
    }

    private updateCompletionMessage(group) {
        var pointsNeeded = group.TotalPointsRequired - group.PointsCompleted;
        var requiredNeeded = group.TotalRequiredItems - group.RequiredItemsCompleted;
        var pointsMessage = pointsNeeded > 0;
        var requiredMessage = requiredNeeded > 0;
        // If it's already complete, return that message 
        if (!pointsMessage && !requiredMessage) {
            group.completionMessage = "Completed!";
            group.IsComplete = true;
            group.overallPercentComplete = 100;
            group.requiredPercentComplete = 100;
        }
        else {
            var msg = "You need ";
            if (pointsMessage)
                msg += pointsNeeded + " point" + ((pointsNeeded == 1) ? "" : "s");
            if (pointsMessage && requiredMessage)
                msg += " and ";
            if (requiredMessage)
                msg += requiredNeeded + ' required item' + ((requiredNeeded == 1) ? "" : "s");
            msg += ".";
            group.IsComplete = false;
            group.overallPercentComplete = Math.round((group.PointsCompleted / group.TotalPointsRequired) * 100);
            if (group.RequiredItemsCompleted == 0 || group.TotalRequiredItems == 0) {
                group.requiredPercentComplete = 0
            } else {
                group.requiredPercentComplete = Math.round((group.RequiredItemsCompleted / group.TotalRequiredItems) * 100);
            }
            group.completionMessage = msg;
        }
    }
}
